import { render, staticRenderFns } from "./CarbonAiRecommend.vue?vue&type=template&id=72fedc59&"
import script from "./CarbonAiRecommend.vue?vue&type=script&lang=js&"
export * from "./CarbonAiRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports